document.addEventListener("DOMContentLoaded", () => {
    document.body.addEventListener("click", (e) => handleBodyClick(e));
    document.body.addEventListener("keydown", (e) => handleKeyDown(e));
});

const handleBodyClick = (e) => {
    const modalTrigger = e.target.closest("[data-modal-src]");
    const imageTrigger = e.target.closest(".js-imageLightbox");
    const videoTrigger = e.target.closest(".js-videoLightbox");
    const testimonialTrigger = e.target.classList.contains("read-more-quote");

    if (testimonialTrigger) {
        const parent = document.querySelector("#testimonial-modal");
        const { contentQuote, contentName, contentTitle } = e.target.closest("[data-content-quote]").dataset;
        updateTestimonialModal(parent, contentQuote, contentName, contentTitle);
        // no early return because this only updates the modal content
    }

    if (modalTrigger) {
        const modalID = modalTrigger.getAttribute("data-modal-src").replace("#", "");
        const modal = document.getElementById(modalID);
        e.preventDefault();
        handleModalEvent(modalID, modal);
        return;
    }

    if (imageTrigger) {
        e.preventDefault();
        openImageModal(imageTrigger);
        return;
    }

    if (videoTrigger) {
        e.preventDefault();
        openVideoModal(videoTrigger);
        return;
    }
};

const handleKeyDown = (e) => {
    if (e.key !== "Enter") {
        return;
    }
    const modalTrigger = e.target.closest("[data-modal-src]");
    if (!modalTrigger) {
        return;
    }
    const modalID = modalTrigger.getAttribute("data-modal-src").replace("#", "");
    const modal = document.getElementById(modalID);
    e.preventDefault();
    handleModalEvent(modalID, modal);
};

const applyModalClasses = (modalID, modal) => {
    const modalElement = modal.querySelector(".c-modal");
    const modalClassMap = {
        "cite-us": ["c-modal--cite-us"],
        "trust-modal": ["c-trust-modal"],
        "cta-modal-simple_modal": ["c-hero-modal", "c-hero-modal--simple"],
        "cta-modal-uk_modal": ["c-hero-modal", "c-hero-modal--uk"],
        "cta-modal-legal_modal": ["c-hero-modal", "c-hero-modal--legal"],
        "inline-legal-modal": ["c-cpb-modal", "c-cpb-legal"]
    };

    if (modalClassMap[modalID]) {
        modalElement.classList.add(...modalClassMap[modalID]);
    }

    if (modalID === "cta-modal-simple_modal") {
        modal.remove();
        document.body.appendChild(modal);
    }
};

const showModal = (modalID) => {
    MicroModal.show(modalID, {
        disableScroll: true,
        onShow: () => toggleLiveChatAriaHidden(true),
        onClose: () => toggleLiveChatAriaHidden(false),
        disableFocus: true
    });

    const modal = document.getElementById(modalID);
    modal.querySelector(".mfp-wrap").style.overflow = "hidden auto";
};

const handleModalEvent = (modalID, modal) => {
    applyModalClasses(modalID, modal);
    showModal(modalID);
};

const toggleLiveChatAriaHidden = (isHidden) => {
    const liveChatDiv = document.getElementById('c-livechat');
    liveChatDiv?.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
};

const updateTestimonialModal = (modalParent, fullQuote, name, title) => {
    const testimonialQuote = modalParent.querySelector(".testimonial-quote-full");
    const testimonialName = modalParent.querySelector(".testimonial-modal-name");
    const testimonialTitle = modalParent.querySelector(".testimonial-modal-title");

    if (testimonialQuote) {
        testimonialQuote.innerHTML = fullQuote;
    }

    if (testimonialName) {
        testimonialName.innerHTML = name;
    }

    if (testimonialTitle) {
        testimonialTitle.innerHTML = title;
    }
};

const openImageModal = (image) => {
    const { href: imageRef, alt: imageAltText } = image;

    if (!document.getElementById("image-modal")) {
        createImageModal(imageRef, imageAltText);
    }

    MicroModal.show("image-modal", {
        disableScroll: true,
        onClose: () => document.getElementById("image-modal").remove()
    });
};

const createImageModal = (src, alt) => {
    const modalHTML = `
        <div class="modal-wrapper c-lightbox--image" id="image-modal" aria-hidden="true">
            <div class="mfp-bg" tabindex="-1"></div>
            <div class="mfp-wrap mfp-close-btn-in">
                <div class="mfp-container" data-micromodal-close>
                    <div class="mfp-content" role="dialog">
                        <div class="mfp-figure">
                            <button class="mfp-close" data-micromodal-close aria-label="Close">x</button>
                            <figure>
                                <img class="mfp-img" alt="${alt}" src="${src}" style="max-height: 880px;">
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
    document.body.insertAdjacentHTML("afterbegin", modalHTML);
};

const openVideoModal = (video) => {
    let videoElement = findParent(video, ".c-video__link");
    if (!videoElement && video.hasAttribute('data-vid') && video.tagName === 'A') {
        videoElement = video;
    }
    const videoID = videoElement.getAttribute("data-vid");
    const videoTitle = videoElement.getAttribute("data-vid-title").trim();

    if (!document.getElementById("video-modal")) {
        createVideoModal(videoID, videoTitle);
    }

    MicroModal.show("video-modal", {
        disableScroll: true,
        onClose: () => document.getElementById("video-modal").remove()
    });
};

const createVideoModal = (videoID, title) => {
    const modalHTML = `
        <div class="modal-wrapper" id="video-modal" aria-hidden="true">
            <div class="mfp-bg"></div>
            <div class="mfp-wrap mfp-close-btn-in">
                <div class="mfp-container" data-micromodal-close>
                    <div class="mfp-content" role="dialog">
                        <div class="mfp-iframe-scaler" aria-modal="true">
                            <button class="mfp-close" data-micromodal-close aria-label="Close">x</button>
                            <iframe src="https://fast.wistia.net/embed/iframe/${videoID}?autoPlay=true&amp;silentAutoPlay=allow"
                                    allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed"
                                    name="wistia_embed" allow="autoplay" allowfullscreen
                                    mozallowfullscreen webkitallowfullscreen oallowfullscreen
                                    msallowfullscreen width="640" height="360" title="${title}">
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
    document.body.insertAdjacentHTML("afterbegin", modalHTML);
};

const findParent = (element, selector) => {
    return element.closest(selector);
};
